import { createReducer, on } from "@ngrx/store";
import { PdfActions, PdfPublicActions } from "./pdf.actions";
import { initialPdfState, ZOOM_MIN, ZOOM_MAX, ZOOM_STEP, ZOOM_DEFAULT } from "./pdf.state";

export const pdfReducer = createReducer(
    initialPdfState,

    // =========================================================================
    // VIEW QUOTE - Token-based (Playwright, public links)
    // =========================================================================
    on(PdfPublicActions.viewQuote, state => ({
        ...state,
        isLoading: true,
    })),

    on(PdfPublicActions.viewQuoteSuccess, (state, { quote }) => ({
        ...state,
        quote,
        error: null,
        isLoading: false,
    })),

    on(PdfPublicActions.viewQuoteFailure, (state, { error }) => ({
        ...state,
        error,
        isLoading: false,
    })),

    // =========================================================================
    // VIEW VENDOR INQUIRY - Token-based (Playwright, public links)
    // =========================================================================
    on(PdfPublicActions.viewVendorInquiry, state => ({
        ...state,
        isLoading: true,
    })),

    on(PdfPublicActions.viewVendorInquirySuccess, (state, { quote }) => ({
        ...state,
        quote,
        error: null,
        isLoading: false,
    })),

    on(PdfPublicActions.viewVendorInquiryFailure, (state, { error }) => ({
        ...state,
        error,
        isLoading: false,
    })),

    // =========================================================================
    // VIEW SUBSCRIPTION - Token-based (Playwright, public links)
    // =========================================================================
    on(PdfPublicActions.viewSubscription, state => ({
        ...state,
        isLoading: true,
    })),

    on(PdfPublicActions.viewSubscriptionSuccess, (state, { quote }) => ({
        ...state,
        quote,
        error: null,
        isLoading: false,
    })),

    on(PdfPublicActions.viewSubscriptionFailure, (state, { error }) => ({
        ...state,
        error,
        isLoading: false,
    })),

    // =========================================================================
    // CURRENCY CONVERTED QUOTE (when version !== company base currency)
    // =========================================================================
    on(PdfActions.getCurrencyConvertedQuote, state => ({
        ...state,
        fetchesCurrencyConvertedQuote: true,
    })),

    on(PdfActions.getCurrencyConvertedQuoteFailure, (state, { error }) => ({
        ...state,
        error,
        fetchesCurrencyConvertedQuote: false,
    })),

    on(PdfActions.clearCurrencyConvertedQuote, state => ({
        ...state,
        fetchesCurrencyConvertedQuote: false,
    })),

    on(PdfActions.getCurrencyConvertedSubscription, state => ({
        ...state,
        fetchesCurrencyConvertedQuote: true,
    })),

    on(PdfActions.getCurrencyConvertedSubscriptionFailure, (state, { error }) => ({
        ...state,
        error,
        fetchesCurrencyConvertedQuote: false,
    })),

    on(PdfActions.clearCurrencyConvertedSubscription, state => ({
        ...state,
        fetchesCurrencyConvertedQuote: false,
    })),

    // =========================================================================
    // VENDOR INQUIRY ITEMS
    // =========================================================================
    on(PdfActions.loadVendorInquiryItems, state => ({
        ...state,
        isLoadingVendorInquiryItems: true,
    })),

    on(PdfActions.loadVendorInquiryItemsSuccess, (state, { items }) => ({
        ...state,
        vendorInquiryItems: items,
        isLoadingVendorInquiryItems: false,
    })),

    on(PdfActions.loadVendorInquiryItemsFailure, (state, { error }) => ({
        ...state,
        error,
        isLoadingVendorInquiryItems: false,
    })),

    // =========================================================================
    // ZOOM
    // =========================================================================
    on(PdfActions.zoomIn, state => ({
        ...state,
        zoomLevel: Math.min(state.zoomLevel + ZOOM_STEP, ZOOM_MAX),
    })),

    on(PdfActions.zoomOut, state => ({
        ...state,
        zoomLevel: Math.max(state.zoomLevel - ZOOM_STEP, ZOOM_MIN),
    })),

    on(PdfActions.resetZoom, state => ({
        ...state,
        zoomLevel: ZOOM_DEFAULT,
    })),

    // =========================================================================
    // RESET
    // =========================================================================
    on(PdfActions.resetState, () => ({ ...initialPdfState })),
);
